<template>
  <div>
    <div class="banner">
        ⭐️ If you like RedStone, join our
        <a
          href="https://discord.com/invite/PVxBZKFr46"
          target="_blank"
          referrerpolicy="no-referrer"
        >
          Discord</a
        >
        and follow us on
        <a
          href="https://twitter.com/redstone_defi"
          target="_blank"
          referrerpolicy="no-referrer"
        >
          X</a
        >
        ⭐️
      </div>
    <Header />
    <Sidebar :class="{ 'collapsed': sidebarCollapsed }" />
    
    <div
      :class="[
        {
          root: true,
          showSidebar: showSidebar,
          'collapsed-sidebar': sidebarCollapsed
        },
        'sing-dashboard',
      ]"
    >
      <div
        class="wrap"
        :class="{ 'expanded-content': sidebarCollapsed }"
      >
        <v-touch
          class="content"
          @swipe="handleSwipe"
          :swipe-options="{ direction: 'horizontal' }"
        >
          <transition name="router-animation">
            <router-view v-if="$route.name !== 'Layout'" />
            <h1 v-else>Redstone Finance App</h1>
          </transition>
        </v-touch>
      </div>
    </div>
  </div>
</template>

<script>
  import { createNamespacedHelpers } from "vuex";
  const { mapState, mapActions } = createNamespacedHelpers("layout");

  import Sidebar from "@/components/Sidebar/Sidebar";
  import Header from "@/components/Header/Header";

  import "./Layout.scss";

  export default {
    name: "Layout",
    components: { Sidebar, Header },
    methods: {
      ...mapActions([
        "switchSidebar",
        "handleSwipe",
        "changeSidebarActive",
        "toggleSidebar",
        "toggleSidebarCollapse"
      ]),
      handleWindowResize() {
        // Update layout if needed on resize
        this.$store.dispatch("layout/initializeState");
      },
    },
    computed: {
      ...mapState([
        "showSidebar", 
        "sidebarCollapsed"
      ]),
    },
    created() {
      // Initialize store state
      this.$store.dispatch("layout/initializeState");
      
      window.addEventListener("resize", this.handleWindowResize);
    },
    beforeDestroy() {
      window.removeEventListener("resize", this.handleWindowResize);
    },
    watch: {
      // Save sidebar state when it changes
      sidebarCollapsed(newValue) {
        localStorage.setItem("sidebarCollapsed", newValue);
      }
    }
  };
</script>